import angular from 'angular';
const FEATURES = [
  {
    key: 1,
    name: 'RelationUserAccess',
  },
  {
    key: 2,
    name: 'Unused',
  },
  {
    key: 4,
    name: 'Unused',
  },
  {
    key: 8,
    name: 'Unused',
  },
  {
    key: 16,
    name: 'ReportPerformanceBalance',
  },
  {
    key: 32,
    name: 'TenantMoore',
  },
  {
    key: 64,
    name: 'Gmail',
  },
  {
    key: 128,
    name: 'IntraCompanyBilling',
  },
  {
    key: 256,
    name: 'ConnectOpenTheBox',
  },
  {
    key: 512,
    name: 'AI',
  },
  {
    key: 1024,
    name: 'ReferenceYear',
  },
  {
    key: 2048,
    name: 'TaskflowBilling',
  },
  {
    key: 4096,
    name: 'AssignmentAnalysis',
  },
  {
    key: 8192,
    name: 'Training',
  },
  {
    key: 1 << 14,
    name: 'DocumentTagUserAccessRestriction',
  },
  {
    key: 1 << 15,
    name: 'CapacityPlanning',
  },
];

angular.module('cloudX').factory('checkFeature', [
  'authService',
  'featureflags',
  function(authService, featureflags) {
    var parseFeatureParam = function(value) {
      if (typeof value === 'undefined' || value === null) return 0;
      if (angular.isArray(value)) {
        /* Allowed array format:
          ['ExtendedPricing','TaskMgmt']
      */
        return value.reduce(function(sec, item) {
          var feature = FEATURES.find(function(f) {
            return f.name.toLowerCase() === item.toLowerCase();
          });
          if (feature) {
            return sec | feature.key;
          }
          return sec;
        }, 0);
      } else if (angular.isString(value)) {
        /* Allowed string formats:
          'ExtendedPricing'
          'ExtendedPricing,TaskMgmt'
      */
        return parseFeatureParam(value.split(','));
      }
      return 0;
    };

    var checkFeaturesFlags = function(value) {
      if (!value) return false;
      if (typeof value !== 'string') return false;
      if (!featureflags) return false;
      return !!featureflags[value.toLowerCase()];
    };

    var service = function(param) {
      var auth = authService.getClaims();
      if (!auth) return false;
      if (checkFeaturesFlags(param)) return true;
      var security = parseFeatureParam(param);
      var permissions = 0;
      try {
        permissions = parseInt(auth.WindowsSubAuthority);
      } catch (ex) {
        permissions = 0;
      }

      return (security & permissions) > 0;
    };
    return service;
  },
]);
